// Importing React and external libs
import React from 'react';
import PropTypes from 'prop-types';

// Importing antd libs
import { Button, Tooltip } from 'antd';
import 'antd/es/button/style/css';
import 'antd/es/tooltip/style/css';

// Importing antd icons
import { EditOutlined } from '@ant-design/icons';

// Importing helix components
import BtnConfirm from 'helix/ui/btnConfirm';

// Importing helix hooks
import useLanguage from 'helix-hooks/language';

// Importing app component
import languages from './lng';

// Importing component style
import './action.scss';

// Exporting component
const Action = (props) => {
  const Language = useLanguage({ languages });
  const { context, custom, disableDelete, record, onEdit, onDelete, editInfo, deleteInfo } = props;
  return (
    <div className="list-column-action-wrapper">
      {custom.map((action) => action(record))}
      {onEdit && (
        <Tooltip title={editInfo ?? Language.get(context, 'EDIT_HOVER_INFO')}>
          <Button className="icon" icon={<EditOutlined />} size="small" onClick={() => onEdit()} />
        </Tooltip>
      )}
      {typeof onDelete === 'function' && (
        <Tooltip placement="bottom" title={deleteInfo ?? Language.get(context, 'DELETE_HOVER_INFO')}>
          <BtnConfirm disabled={disableDelete} onConfirm={() => onDelete()} />
        </Tooltip>
      )}
    </div>
  );
};

Action.propTypes = {
  custom: PropTypes.array,
  disableDelete: PropTypes.bool,
};

Action.defaultProps = {
  custom: [],
  disableDelete: false,
};

export default Action;
